import React from 'react';
import { Switch } from 'router';
import PolicyEditorPage from './page-new';
import PolicyDetailsPage from './page-details';
import { UserRoleType } from 'graphql.g';
import { useUser } from 'common/user';
import PolicyDashboardPage from './page-dashboard';
import PolicyListPage from './page-list';

function PolicyPage() {
    const { isStaff, orgAuth } = useUser();

    const canManagePolicies =
        orgAuth.organization.__typename === 'AgencyOrganization' &&
        (orgAuth.role === UserRoleType.Administrator || isStaff);
    return (
        <>
            <Switch
                pages={[
                    ...(canManagePolicies
                        ? [
                              {
                                  path: '/form/:mode',
                                  component: PolicyEditorPage
                              }
                          ]
                        : []),
                    {
                        path: '/dashboard',
                        exact: true,
                        component: PolicyDashboardPage
                    },
                    {
                        path: '/active',
                        exact: true,
                        component: PolicyListPage
                    },
                    {
                        path: '/ended',
                        exact: true,
                        component: PolicyListPage
                    },
                    {
                        path: '/',
                        exact: true,
                        redirectTo: '/dashboard'
                    },
                    {
                        path: '/:policyId',
                        component: PolicyDetailsPage
                    }
                ]}
            />
        </>
    );
}

export default PolicyPage;
